import request from "@/utils/request";

export default function agentChangeDeviceQRCode(code, deviceId) {
    return request({
        url: `/device/deviceQRCode/agentChangeDeviceQRCode/${code}/${deviceId}`,
        method: 'post',
    })
}
